<template>
    <div class="vacancy-cards" v-if="vacancyPage != null">
        <!-- {{vacancyItems}} -->

        <div class="card-item" v-for="(item, index) in vacancyItems"  :key="index" :class="{open : currentIndex == index}">
            <div class="city">
                <h4>{{item.city.name}}</h4>
            </div>
            <div class="title">
                <h3>{{item.name}}</h3>
            </div>
            <a href="#" @click.prevent="setCurrentIndex(index)" class="link-more">
                <div class="icon-elem">
                    <svgIcon name="arrow-down" class="icon-arrow-down"/>
                </div>
                <span class="open">Подробнее</span>
                <span class="close">Свернуть</span>
            </a>
            <slide-up-down :active="currentIndex == index" :duration="400" class="dropdown-desc">
                <div class="column-container-inner">
                    <div class="col-left">
                        <div class="desc-items">
                            <div class="item" v-for="desc in item.vac_desc">
                                <h3>{{desc.title}}</h3>
                                <div class="list" v-if="desc.list != false">
                                    <ul>
                                        <li v-for="list in desc.list">{{list.desc}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-right">
                        <formVacancy :options="[{email: item.email_admin, city: item.city, title: item.name}]"></formVacancy>
                    </div>
                </div>
            </slide-up-down>
        </div>

        <!-- <li v-for="(item, index) in setup.main_page_navigation" class="parent-link" :data-href="item.href" :key="index" :class="{open : currentIndex == index}">
            <a href="#" @click.prevent="setCurrentIndex(index, item.href)">
                <span>{{item.name}}</span>
                <div class="nav-icon" v-if="item.dropdown != false"></div>
            </a>
            
        </li> -->
    </div>
</template>

<script>
    import formVacancy from '@/components/forms/form-vacancy.vue'
    import SlideUpDown from 'vue-slide-up-down'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'vacancy-cards',
        components: {
            SlideUpDown,
            formVacancy,
            svgIcon,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                currentIndex: -1,
            }
        },
        computed: mapGetters({
            vacancyPage: 'loadVacancyPage',
            vacancyItems: 'loadVacancyItems',
        }),
        methods: {
            setCurrentIndex(index) {
                if (this.currentIndex == index) {
                    this.currentIndex = null;
                } else {
                    this.currentIndex = index
                }
                // console.log(index)
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.buildFiterCity();
            // // this.initFilterCityByPageLoad();
            // this.$store.watch(
            //     (state) => state.projectItemsFilter,
            //     (newValue) => {
            //         this.buildFiterCity();
            //         // this.initFilterCityByPageLoad();
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/vacancy-page/vacancy-cards.scss';
    @import '@/styles/components/vacancy-page/respond/vacancy-cards-respond.scss';
    // @import '@/styles/respond/vacancy/vacancy-cards-respond.scss';
</style>